import {Component, OnInit, HostListener } from "@angular/core";
import {Router, NavigationEnd} from "@angular/router";
import {AuthService} from "../service/auth/auth.service";
import {HttpService} from "../service/http/http.service";
import {environment} from "../../environments/environment";
import {NotificationService} from "../service/notification/notification.service";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [NotificationService]
})
export class HeaderComponent implements OnInit {

  app: boolean;
  scrollTop: number = 0;
  english: boolean;
  isApp: boolean;

  public isHome = false;
  public showSubMenu = false;
  public showMobileMenu = false;
  public expanded = null;

  constructor(private httpService: HttpService,
              public authGuard: AuthService,
              private router: Router,
              private notificationService: NotificationService) {
    this.app = environment.app;
    this.english = environment.english;
    this.isHome = this.router.url == '/';
    this.expanded = '';

    let userAgent = window.navigator.userAgent;
    this.isApp = userAgent.indexOf('hey_application') > -1

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }

      this.isHome = evt.urlAfterRedirects == '/';
      this.showSubMenu = false;
      this.showMobileMenu = false;
      window.scrollTo(0, 0);
    });
  }

  ngOnInit() {
  }

  routerCanDeactivate() {
    this.closeMobileMenu();
    return true; // false stops navigation, true continue navigation
  }

  logout() {
    if (environment.app) {
      const notificationService = this.notificationService;
      const httpService = this.httpService;
      FCMPlugin.getToken(function (token) {
        notificationService.unregist(token).subscribe(
          res => {},
          err => {},
          () => httpService.logout()
        );
      });
    } else {
      this.httpService.logout();
    }
  }

  openMobileMenu() {
    this.showMobileMenu = true;
  }

  closeMobileMenu() {
    this.showMobileMenu = false;
  }

  onMenuOpen(): boolean {
    return this.showMobileMenu;
  }

  selectedMenu(menu: string) {
    this.expanded = (this.expanded == menu) ? null : menu;
  }
}




// WEBPACK FOOTER //
// ./src/app/header/header.component.ts